var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { SubCategoryLink } from "./SubCategoryLink";
import { Item } from "../Item";
export var SubCategory = function (_a) {
    var title = _a.title, link = _a.link, children = _a.children, isAlternative = _a.isAlternative;
    return (React.createElement("div", { className: "md:mt-10 md:first:mt-0" },
        React.createElement("div", null,
            React.createElement("p", { className: "flex justify-between uppercase md:mb-4 px-4 md:px-0 pt-5 pb-2 md:pb-4 md:pt-0 md:border-b border-gray-100 text-text-secondary font-semibold text-xs tracking-2" },
                React.createElement("span", null, title),
                link && React.createElement(SubCategoryLink, __assign({ className: "hidden md:block" }, link)))),
        children.map(function (item, index) { return (React.createElement(Item, __assign({}, item, { key: index, isAlternative: isAlternative }))); }),
        link && (React.createElement(SubCategoryLink, __assign({ className: "md:hidden font-semibold text-xs tracking-2 pl-4" }, link)))));
};
//# sourceMappingURL=SubCategory.js.map